<template>
  <v-container>
    <v-dialog
      overlay-color="grey"
      overlay-opacity="0.7"
      :value="dialog"
      @input="dialog = $event"
      max-width="1000"
      scrollable
      content-class="review-dialog"
    >
      <v-card class="review-dialog-card">
        <v-card-title class="review-dialog-header d-flex">
          <v-icon size="24" color="primary" class="mr-2">mdi-comment-quote</v-icon>
          <span class="text-h5">수강 리뷰 상세</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('hideDialog')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider></v-divider>
        
        <card-review
          :selected-review="selectedReview"
          class="review-card-content"
        />
        
        <v-card-actions class="review-dialog-footer">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            rounded
            @click="$emit('hideDialog')"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            돌아가기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import CardReview from "@/components/Card/CardReview";

export default {
  components: {CardReview},
  data() {
    return {
      min: 30,
      rating: 3,
      searchQuery: {
        orderId: ''
      },
      assign: {},
    };
  },
  props: {
    value: {type: Boolean, required: true},
    selectedReview: {type: Object }
  },
  created() {   },
  beforeMount() {  },
  async mounted() {  },
  watch: { },
  destroyed() {},
  filters: { },
  computed: {
    ...mapGetters(['app', 'user', 'isManager']),
    dialog: {
      get() {return this.value},
      set(value) {this.$emit('input', value)},
    },
  },
  methods: {  },
};
</script>

<style lang="scss" scoped>
.review-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.review-dialog-card {
  border-radius: 16px;
  overflow: hidden;
}

.review-dialog-header {
  background-color: #f8f9fa;
  padding: 16px 20px;
}

.review-card-content {
  padding: 0 !important;
  
  // Target Card elements within the CardReview component
  :deep(.v-card) {
    box-shadow: none !important;
    background-color: transparent !important;
  }
  
  :deep(.v-card__subtitle) {
    text-align: left;
    padding: 16px 16px 0;
  }
  
  :deep(.v-card__text) {
    padding: 16px;
  }
  
  :deep(.v-card__actions) {
    padding: 16px;
    justify-content: flex-start;
  }
  
  :deep(.v-textarea) {
    border-radius: 8px;
  }
  
  :deep(.v-rating) {
    justify-content: flex-start;
  }
  
  :deep(.v-btn) {
    margin: 0;
  }
}

.review-dialog-footer {
  background-color: #f8f9fa;
  padding: 12px 20px;
}

// Dark mode support
.theme--dark {
  .review-dialog-header,
  .review-dialog-footer {
    background-color: #1e1e1e;
  }
}
</style>
